export const FETCH_NAVIGATION_PENDING = 'FETCH_NAVIGATION_PENDING';
export const FETCH_NAVIGATION_FULFILLED = 'FETCH_NAVIGATION_FULFILLED';
export const FETCH_NAVIGATION_FAILED = 'FETCH_NAVIGATION_FAILED';
export const FETCH_INITIAL_NAVIGATION_FULFILLED = 'FETCH_INITIAL_NAVIGATION_FULFILLED';
export const SET_MOBILE_NAVIGATION_STATE_FULFILLED = 'SET_MOBILE_NAVIGATION_STATE_FULFILLED';
export const SET_HEADER_NAVIGATION_STATE_FULFILLED = 'SET_HEADER_NAVIGATION_STATE_FULFILLED';
